import { Link } from 'react-router-dom'
import { contact } from '../data/site'

export function NotFound() {
  return (
    <section className="not-found shell">
      <span className="eyebrow">404</span>
      <h1>This page slipped out for a trim.</h1>
      <p>The page you requested could not be found.</p>
      <div className="button-row">
        <Link className="button" to="/">Return Home</Link>
        <Link className="text-link" to="/team">Meet Our Team</Link>
        <a className="text-link" href={contact.bookingUrl} target="_blank" rel="noopener noreferrer">Book an Appointment</a>
        <Link className="text-link" to="/contact">Contact the Salon</Link>
      </div>
    </section>
  )
}
